import { makeAutoObservable } from 'mobx'

export class ReviewStore {
  private _agreePrivacy = false
  private _agreeTerms = false
  private _agreeCtia = false

  constructor() {
    makeAutoObservable(this)
  }

  get agreePrivacy() {
    return this._agreePrivacy
  }

  get agreeTerms() {
    return this._agreeTerms
  }

  get agreeCtia() {
    return this._agreeCtia
  }

  get isSubmitDisabled() {
    return !(this._agreePrivacy && this._agreeTerms && this._agreeCtia)
  }

  toggleAgreePrivacy = () => {
    this._agreePrivacy = !this._agreePrivacy
  }

  toggleAgreeTerms = () => {
    this._agreeTerms = !this._agreeTerms
  }

  toggleAgreeCtia = () => {
    this._agreeCtia = !this._agreeCtia
  }

  reset = () => {
    this._agreePrivacy = false
    this._agreeTerms = false
    this._agreeCtia = false
  }
}
